/** Adds `download=1` to a signed content URL so the browser saves the file (Files API, ARCHITECTURE §4.7). */
export function toDownloadUrl(url: string): string {
  try {
    const parsed = new URL(url, window.location.origin);
    parsed.searchParams.set('download', '1');
    return parsed.origin === window.location.origin ? parsed.pathname + parsed.search : parsed.toString();
  } catch {
    return url;
  }
}
